import { RecurringInvoice } from "@wingspanhq/wingspan-api-sdk";
import { selectorIsRecurringSeries } from "./selectorIsRecurringSeries";

export type RecurringInvoiceActionLabels = {
  noun: string;
  edit: string;
  cancel: string;
  keep: string;
};

const SERIES_LABELS: RecurringInvoiceActionLabels = {
  noun: "series",
  edit: "Edit series",
  cancel: "Cancel series",
  keep: "Keep series"
};

const SINGLE_INVOICE_LABELS: RecurringInvoiceActionLabels = {
  noun: "invoice",
  edit: "Edit invoice",
  cancel: "Cancel invoice",
  keep: "Keep invoice"
};

export const selectorRecurringInvoiceActionLabels = (
  recurringInvoice: RecurringInvoice
): RecurringInvoiceActionLabels =>
  selectorIsRecurringSeries(recurringInvoice)
    ? SERIES_LABELS
    : SINGLE_INVOICE_LABELS;
